import { TYPE_STRING } from './input-types';

export const id = 'addressLine1';
export const apiKey = 'AddressLine1';
export const type = TYPE_STRING;

export const addressLine1 = {
  id,
  apiKey,
  type,
};
